// ── Deals ──────────────────────────────────────────────
export const DEAL_STATUS = {
  OPEN: 'open',
  WON: 'won',
  LOST: 'lost',
} as const;

// ── Leads ──────────────────────────────────────────────
export const LEAD_STATUS = {
  NEW: 'new',
  EM_NEGOCIACAO: 'em_negociacao',
  CLIENTE: 'cliente',
  PERDIDO: 'perdido',
  INATIVO: 'inativo',
} as const;

// ── Financeiro — CANONICAL: double L em cancelled ─────
export const RECEIVABLE_STATUS = {
  OPEN: 'open',
  RECEIVED: 'received',
  OVERDUE: 'overdue',
  CANCELLED: 'cancelled',
} as const;

export const PAYABLE_STATUS = {
  OPEN: 'open',
  PAID: 'paid',
  OVERDUE: 'overdue',
  CANCELLED: 'cancelled',
} as const;

// ── Propostas ──────────────────────────────────────────
export const PROPOSAL_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  VIEWED: 'viewed',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
} as const;

// ── Contratos ──────────────────────────────────────────
export const CONTRACT_STATUS = {
  DRAFT: 'draft',
  SENT: 'sent',
  SIGNED: 'signed',
  CANCELLED: 'cancelled',
} as const;

// ── Projetos de instalação ─────────────────────────────
export const PROJECT_STATUS = {
  PENDING_DELIVERY: 'pending_delivery',
  DELIVERING: 'delivering',
  INSTALLING: 'installing',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
} as const;

// ── Tenant ─────────────────────────────────────────────
export const TENANT_STATUS = {
  ACTIVE: 'active',
  TRIAL: 'trial',
  SUSPENDED: 'suspended',
  CANCELLED: 'cancelled',
} as const;

// ── Subscription ───────────────────────────────────────
export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  TRIALING: 'trialing',
  TRIAL_EXPIRED: 'trial_expired',
  SUSPENDED: 'suspended',
  CANCELLED: 'cancelled',
} as const;

// ── Tasks ──────────────────────────────────────────────
export const TASK_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
} as const;

// ── SaaS Invoices ──────────────────────────────────────
export const INVOICE_STATUS = {
  DRAFT: 'draft',
  PENDING: 'pending',
  PAID: 'paid',
  OVERDUE: 'overdue',
} as const;

// ── WhatsApp ───────────────────────────────────────────
export const WHATSAPP_STATUS = {
  PENDING: 'pending',
  SENT: 'sent',
  FAILED: 'failed',
} as const;

// ── Display configs reutilizáveis ──────────────────────

export const LEAD_STATUS_CONFIG: Record<string, { label: string; variant: "default" | "secondary" | "outline" | "destructive"; className?: string }> = {
  [LEAD_STATUS.NEW]: { label: "Prospect", variant: "outline", className: "border-amber-400 text-amber-600 bg-amber-50" },
  [LEAD_STATUS.EM_NEGOCIACAO]: { label: "Em Negociação", variant: "outline", className: "border-blue-400 text-blue-600 bg-blue-50" },
  [LEAD_STATUS.CLIENTE]: { label: "Cliente", variant: "outline", className: "border-emerald-400 text-emerald-600 bg-emerald-50" },
  [LEAD_STATUS.PERDIDO]: { label: "Perdido", variant: "outline", className: "border-red-300 text-red-500 bg-red-50" },
  contacted: { label: "Contatado", variant: "secondary" },
  qualified: { label: "Qualificado", variant: "outline" },
  lost: { label: "Perdido", variant: "destructive" },
};

export const PROPOSAL_STATUS_CONFIG: Record<string, { label: string; variant: "default" | "secondary" | "outline" | "destructive"; className?: string }> = {
  [PROPOSAL_STATUS.DRAFT]: { label: "Rascunho", variant: "secondary" },
  [PROPOSAL_STATUS.SENT]: { label: "Enviada", variant: "outline", className: "border-blue-400 text-blue-600 bg-blue-50" },
  [PROPOSAL_STATUS.VIEWED]: { label: "Visualizada", variant: "outline", className: "border-purple-400 text-purple-600 bg-purple-50" },
  [PROPOSAL_STATUS.APPROVED]: { label: "Aprovada", variant: "outline", className: "border-emerald-400 text-emerald-600 bg-emerald-50" },
  [PROPOSAL_STATUS.REJECTED]: { label: "Rejeitada", variant: "destructive" },
  [PROPOSAL_STATUS.CANCELLED]: { label: "Cancelada", variant: "outline", className: "border-red-300 text-red-500 bg-red-50" },
};
